import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { loginSPremiumUser } from "../modules/actions";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      loginSPremiumUser,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
